import { GraphQLError } from 'graphql';
import { gotoLogin } from 'hooks/useLogin';

export const ERROR_MESSAGES = {
    1800002: '该规格不存在，请选择其他',
    20112203: '该商品超过最大售卖数量',
    2143009: '子账号无操作权限',
    1600006: '订单已支付或者已取消',
    20121308: '频繁获取验证码，请稍后再试',
    20121303: '请重新获取验证码',
    20121301: '订单金额低于10元，请使用其他支付方式',
    20116003: '对不起，当日试用已达上限，您可直接购买~',
    20113004: '该商品暂不支持售卖',
    40001: '系统正忙，请稍候再试',
    20112200: '请勿重复提交订单',
    10014: '当前优惠券已使用或已过期，请重新选择',
    800001: '售卖方式不支持',
    20092401: '该订单商品有失效/库存不足，请重新下单',
    20113012: '该订单商品已下架，请重新下单',
    2140001: '超过时间限制，请重新选择续费DSK',
    1100001: '操作失败, 请稍后重试',
    20116002: '您当前不满足申请试用的条件，请按照试用流程操作后再申请',
    1800003: '该规格不存在，请选择其他',
    20092202: '卡券已经使用或者不存在',
    INTERNAL_SERVER_ERROR: '系统开小差啦~',
    VOUCHER_NOT_ENOUGH: '服务码/兑换码数量不足，请重新选择。',
    40029: 'DSK 不存在',
    40080: 'AK 不存在',
    80001: 'ntrip 账号不存在',
    20119009: '账号异常，请联系客服',
};

export default class ErrorHandler {
    private toaster = alert;

    private workInProcess = false;

    constructor(props: { toaster: (msg: string) => void }) {
        this.toaster = props.toaster;
    }

    // 避免多个错误一起提示
    private doShowMessage(msg: string) {
        if (!this.workInProcess) {
            this.workInProcess = true;
            this.toaster(msg);
            setTimeout(() => {
                this.workInProcess = false;
            }, 3000);
        }
    }

    showError(codeOrMsg: string) {
        this.doShowMessage(ERROR_MESSAGES[codeOrMsg] || codeOrMsg);
    }

    showGraphqlErrors(graphQLErrors: readonly GraphQLError[]) {
        if (!Array.isArray(graphQLErrors)) {
            return;
        }
        for (let i = 0; i < graphQLErrors.length; i += 1) {
            const error = graphQLErrors[i];
            if (error.extensions) {
                if (error.extensions.code === 'UNAUTHENTICATED') {
                    gotoLogin();
                    break;
                }
                if (ERROR_MESSAGES[error.extensions.code]) {
                    this.doShowMessage(ERROR_MESSAGES[error.extensions.code]);
                    break;
                }
                if (error.message) {
                    this.doShowMessage(error.message);
                    break;
                }
            }
        }
    }

    showNetworkErrors() {
        this.doShowMessage('当前的网络连接存在问题，请检查网络设置~');
    }

    /* eslint-disable class-methods-use-this */
    public getGraphqlErrorCode(graphQLErrors: readonly GraphQLError[]) {
        if (!Array.isArray(graphQLErrors)) {
            return null;
        }
        for (let i = 0; i < graphQLErrors.length; i += 1) {
            const error = graphQLErrors[i];
            if (error.extensions && error.extensions.code) {
                return error.extensions.code;
            }
        }
        return null;
    }
}
